

export const getProvinceBasic = (that) => {
  return new Promise((resolve, reject) => {
    const uri = "getProvincesBasic";
    const params = {};
    that.$json(uri, params).then(response => {
      resolve(response.record);
    });
  });
};
export default {
  getProvinceBasic
};




// WEBPACK FOOTER //
// ./src/utils/province.js